var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HeatmapReport',{staticClass:"maxh-1bar",attrs:{"fetcher":this}})}
var staticRenderFns = []

export { render, staticRenderFns }